const { render, useState } = wp.element;
import React, { Component } from 'react';
import { withTranslation } from "react-i18next";
import { connect } from 'react-redux';

//Import Designs
import { Grid2, AppBar, Toolbar, Button, Tooltip, Typography } from '@mui/material';

import CameraAltIcon from '@mui/icons-material/CameraAlt';
import StarIcon from '@mui/icons-material/Star';
import GavelIcon from '@mui/icons-material/Gavel';


class SingleNavigation extends Component {
    constructor(props) {
        super(props);
        this.state = {
            fontcolor: '', hover_back: '', listcolor: '', gridcolor: '', btn_number: '', show_login: false,
            galleryfontcolor: null, galleryhover_back: null, tenfontcolor: null, tenhover_back: null,
            formfontcolor: null, formhover_back: null, rulesfontcolor: null, ruleshover_back: null,
            profilefontcolor: null, profilehover_back: null,
        };
    }

    toggleHover = (value, name) => () => {
        switch (name) {
            case 'gallery':
                this.setState({
                    galleryfontcolor: value,
                    galleryhover_back: this.props.vote_navbar_active_button_background
                })
                break;
            case 'topten':
                this.setState({
                    tenfontcolor: value,
                    tenhover_back: this.props.vote_navbar_active_button_background
                })
                break;
            case 'rules':
                this.setState({
                    rulesfontcolor: value,
                    ruleshover_back: this.props.vote_navbar_active_button_background
                })
                break;
        }
    }

    toggleleave = (value, name) => () => {
        switch (name) {
            case 'gallery':
                this.setState({
                    galleryfontcolor: value,
                    galleryhover_back: null,
                })
                break;
            case 'topten':
                this.setState({
                    tenfontcolor: value,
                    tenhover_back: null
                })
                break;
            case 'rules':
                this.setState({
                    rulesfontcolor: value,
                    ruleshover_back: null
                })
                break;
        }
    }

    componentDidMount = () => {
        this.setState({
            galleryfontcolor: this.props.votes_navigation_text_color,
            tenfontcolor: this.props.votes_navigation_text_color,
            rulesfontcolor: this.props.votes_navigation_text_color,
        });
    }

    render() {
        const { t, i18n } = this.props;
        const { votes_navigation_font_size, votes_navigation_text_color, votes_navigation_text_color_hover, votes_navigationbgcolor, vote_navbar_active_button_background } = this.props;
        const allprops = this.props;

        let custom_link_gal = (allprops.short.allcatoption.middle_custom_navigation) ? allprops.short.allcatoption.middle_custom_navigation : null;

        const contest_url = (typeof allprops.short !== "undefined") ? allprops.short.contest_url : null;

        const term_name = (typeof allprops.post_single !== "undefined") ? allprops.post_single.term_name : null;
        return (
            (<Grid2 container className="wpvc_single_navigation">
                <Grid2 container size={12} className="wpvc_navigation_bar">
                    <AppBar position="static" className="wpvc_app_bar" style={{ backgroundColor: votes_navigationbgcolor }} enableColorOnDark>
                        <Toolbar>
                            <Grid2
                                container
                                className="wpvc_single_navigation"
                                size={{
                                    xs: 6,
                                    md: 9
                                }}>

                                {this.props.short.showgallery == 1 &&
                                    <Tooltip title={t("gallery")} placement="top-start">
                                        <Button className="wpvc_navigation"
                                            onMouseOver={this.toggleHover(votes_navigation_text_color_hover, 'gallery')}
                                            onMouseLeave={this.toggleleave(votes_navigation_text_color, 'gallery')}
                                            startIcon={<CameraAltIcon />} size="small"
                                            style={{
                                                fontSize: votes_navigation_font_size + 'px',
                                                'color': (this.props.view == 'gallery') ? votes_navigation_text_color_hover : this.state.galleryfontcolor,
                                                backgroundColor: (this.props.view == 'gallery') ? vote_navbar_active_button_background : this.state.galleryhover_back
                                            }}
                                            href={(custom_link_gal ? custom_link_gal : contest_url) + '?view=contest-gallery'}
                                        >
                                            <span className="wpvc_nav_text">
                                                {t("gallery")}
                                            </span>
                                        </Button>
                                    </Tooltip>
                                }

                                {this.props.short.showtop == 1 || this.props.short.showtop == 'on' &&
                                    <Tooltip title={t("top_ten")} placement="top-start">
                                        <Button className="wpvc_navigation"
                                            onMouseOver={this.toggleHover(votes_navigation_text_color_hover, 'topten')}
                                            onMouseLeave={this.toggleleave(votes_navigation_text_color, 'topten')}
                                            startIcon={<StarIcon />} size="small"
                                            style={{
                                                fontSize: votes_navigation_font_size + 'px',
                                                'color': (this.props.view == 'topten') ? votes_navigation_text_color_hover : this.state.tenfontcolor,
                                                backgroundColor: (this.props.view == 'topten') ? vote_navbar_active_button_background : this.state.tenhover_back
                                            }}
                                            href={(custom_link_gal ? custom_link_gal : contest_url) + '?view=contest-topten'}
                                        >
                                            <span className="wpvc_nav_text">
                                                {t("top_ten")}
                                            </span>
                                        </Button>
                                    </Tooltip>
                                }

                                {this.props.short.showrules == 1 &&
                                    <Tooltip title={t("rules")} placement="top-start">
                                        <Button className="wpvc_navigation"
                                            onMouseOver={this.toggleHover(votes_navigation_text_color_hover, 'rules')}
                                            onMouseLeave={this.toggleleave(votes_navigation_text_color, 'rules')}
                                            startIcon={<GavelIcon />} size="small"
                                            style={{
                                                fontSize: votes_navigation_font_size + 'px',
                                                'color': (this.props.view == 'rules') ? votes_navigation_text_color_hover : this.state.rulesfontcolor,
                                                backgroundColor: (this.props.view == 'rules') ? vote_navbar_active_button_background : this.state.ruleshover_back
                                            }}
                                            href={(custom_link_gal ? custom_link_gal : contest_url) + '?view=contest-rules'}
                                        >
                                            <span className="wpvc_nav_text">
                                                {t("rules")}
                                            </span>
                                        </Button>
                                    </Tooltip>
                                }

                            </Grid2>
                            <Grid2
                                size={{
                                    xs: 6,
                                    md: 3
                                }}>
                                <Typography className="wpvc_single_top_category">{t("category") + " : " + term_name}</Typography>
                            </Grid2>
                        </Toolbar>
                    </AppBar>
                </Grid2>
            </Grid2>)
        );
    }
}

export default connect()(withTranslation("translations")(SingleNavigation));
